import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})

export class EmployeeService {
  httpOptions = {
    headers: new HttpHeaders(
      {
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token')
      },
    ),
  };
  private apiUrl = environment.apiUrl;
  constructor(private http: HttpClient) { }

  buildUrl(url, available, subCompetencyId, subCompetency, searchText) {
    if (available != "-1")
      url = `${url}&IsAvailable=${available}`;
    if (subCompetency != null)
      url = `${url}&SubCompetency=${subCompetency}`
    if (searchText != null)
      url = `${url}&Search=${searchText}`
    return url
  }
  bulidFilterResourseUrl(url, subCompetency, searchText) {
    if (subCompetency != null)
      url = `${url}&SubCompetency=${subCompetency}`
    if (searchText != null)
      url = `${url}&Search=${searchText}`
    return url

  }
  buildFetchEmployeeByCompIdUrl(url, resumeupload, profileStatus, subCompetencyId, searchText, country, IsCertified, IsAvailability, IsResigned, isNotUpdatedSince3Months, isSme) {
    if (resumeupload != "-1")
      url = `${url}&ResumeStatus=${resumeupload}`;
    if (profileStatus != "-1")
      url = `${url}&EmployeeProfileStatus=${profileStatus}`;
    if (subCompetencyId != null && subCompetencyId != 0 && !Number.isNaN(subCompetencyId))
      url = `${url}&SubCompetencyId=${subCompetencyId}`
    if (searchText != null)
      url = `${url}&Search=${searchText}`
    if (country != null)
      for (var cou of country) {
        url = `${url}&Country=${cou}`


      }


    if (IsCertified != null)
      url = `${url}&IsCertified=${IsCertified}`
    if (IsAvailability != null) {
      url = `${url}&IsAvailability=${IsAvailability}`
    }
    if (IsResigned != null) {
      url = `${url}&IsResigned=${IsResigned}`
    }
    if (isNotUpdatedSince3Months != null) {
      url = `${url}&IsNotUpdatedSince3Months=${isNotUpdatedSince3Months}`;
    }
    if (isSme != 0) {
      url = `${url}&IsSme=${isSme}`;

    }
    return url
  }
  public getEmployees(from: number, size: number, search: string) {
    const url = `${this.apiUrl}Profile/FetchProfiles`;
    return this.http.post<any>(url, { from, size, search }, this.httpOptions);
  }
  public updateEmployee(body: any) {

    const url = this.apiUrl + 'Profile/EditProfile';
    return this.http.put<any>(url, body, this.httpOptions);
  }
  public draftEmployee(body: any) {
    const url = this.apiUrl + 'Profile/SaveDraftForApproval';
    return this.http.post<any>(url, body, this.httpOptions);
  }
  public approveEmployee(body: any) {
    const url = this.apiUrl + 'Profile/EditAndApprove';
    return this.http.put<any>(url, body, this.httpOptions);
  }
  public updateRole(employeeId: number, markAsAdmin: boolean) {
    const url = this.apiUrl + 'Profile/UpdateRole?' + 'employeeId=' + employeeId + '&markAsAdmin=' + markAsAdmin;

    return this.http.put<any>(url, { employeeId, markAsAdmin }, this.httpOptions);
  }
  public getAllCertifiedResources(from: number, size: number, competencyId, Resumefilter: number, available, subCompetencyId, subCompetency, searchText) {

    let url = `${this.apiUrl}Certificate/GetAllCertifiedResources?from=${from}&size=${size}&competencyId=${competencyId}`;
    url = this.buildUrl(url, available, subCompetencyId, subCompetency, searchText)
    return this.http.get<any>(url, this.httpOptions);
  }
  public getAllCertificationInProgressResources(from: number, size: number, competencyId, Resumefilter: number, available, subCompetencyId, subCompetency, searchText) {
    let url = `${this.apiUrl}Certificate/GetAllCertificationInProgressResources?from=${from}&size=${size}&competencyId=${competencyId}`;
    url = this.buildUrl(url, available, subCompetencyId, subCompetency, searchText)
    return this.http.get<any>(url, this.httpOptions);
  }
  public getAllCompetenciesWithCount() {
    const url = `${this.apiUrl}Competency/GetAllCompetenciesWithCount`;
    return this.http.get<any>(url, this.httpOptions);
  }
  public getAvailableProfilesbyCompetencyId(from: number, size: number, competencyId, available, subCompetencyId, subCompetency, searchText) {
    let url = `${this.apiUrl}Profile/GetAvailableProfilesbyCompetencyId?from=${from}&size=${size}&competencyId=${competencyId}`;
    url = this.buildUrl(url, available, subCompetencyId, subCompetency, searchText)
    return this.http.get<any>(url, this.httpOptions);
  }
  public getAllAvailableResources(from: number, size: number, competencyId, available, subCompetencyId, subCompetency, searchText) {
    let url = `${this.apiUrl}Profile/GetAllAvailableResources?from=${from}&size=${size}&competencyId=${competencyId}`;
    url = this.buildUrl(url, available, subCompetencyId, subCompetency, searchText)
    return this.http.get<any>(url, this.httpOptions);
  }
  public getAllSMEs(from: number, size: number, competencyId, available, subCompetencyId, subCompetency, searchText) {
    let url = `${this.apiUrl}SME/GetAllSMEs?from=${from}&size=${size}&competencyId=${competencyId}`;
    url = this.buildUrl(url, available, subCompetencyId, subCompetency, searchText)
    return this.http.get<any>(url, this.httpOptions);
  }
  public fetchResume(empId) {
    const url = `${this.apiUrl}Profile/GetResume?employeeId=${empId}`;
    return this.http.get<any>(url, this.httpOptions);
  }
  public getEmployeeDetails(employeeId) {
    const url = `${this.apiUrl}Profile/GetEmployeeInfo?employeeId=${employeeId}`;
    return this.http.get<any>(url, this.httpOptions);
  }
  public GetProfileDetailsById(employeeId) {
    const url = `${this.apiUrl}Profile/GetProfileDetailsById?employeeId=${employeeId}`;
    return this.http.get<any>(url, this.httpOptions);
  }
  // public GetProfileDetailsById() {
  //   const url = `${this.apiUrl}Profile/GetProfileDetailsById`;
  //   return this.http.get<any>(url, this.httpOptions);
  // }
  public getAllCompetencies() {
    const url = `${this.apiUrl}Competency/competencies`;
    return this.http.get<any>(url, this.httpOptions);
  }
  public getSubCompetencyByCompetencyId(compitencyId) {
    const url = `${this.apiUrl}Competency/${compitencyId}/subcompetencies`;
    return this.http.get<any>(url, this.httpOptions);
  }
  public saveEmployeeDetails(employee) {
    const url = `${this.apiUrl}Profile/saveEmployeeDetails`;
    return this.http.post<any>(url, employee, this.httpOptions);
  }
  public getServiceAreasByCompetencyId(competencyId) {
    const url = `${this.apiUrl}Competency/GetServiceAreasByCompetencyId?competencyId=${competencyId}`;
    return this.http.get<any>(url, this.httpOptions);
  }
  public getAllPrimarySkills(competencyId, subCompetencyIds, search: string) {
    const url = `${this.apiUrl}Competency/GetAllSkills?search=${search}`;
    const requestData = {
      competencyId: competencyId,
      subCompetencyIds: subCompetencyIds



    };
    return this.http.post<any>(url, [requestData], this.httpOptions);

  }
  public getAllSecondarySkills(competencyId, subCompetencyIds, search) {
    const url = `${this.apiUrl}Competency/GetAllSkills?search=${search}`;
    const requestData = {
      competencyId: competencyId,
      subCompetencyIds: [subCompetencyIds]

    };
    return this.http.post<any>(url, [requestData], this.httpOptions);
  }
  public getEmployeesOnSearch(searchText) {
    const url = `${this.apiUrl}Profile/Autocomplete?search=${searchText}`;
    return this.http.get<any>(url, this.httpOptions);
  }
  public getCertificationTypes(searchText) {
    const url = `${this.apiUrl}Certificate/CertificationTypes?search=${searchText}`;
    return this.http.get<any>(url, this.httpOptions);
  }
  public getSMEFactories() {
    const url = `${this.apiUrl}SME/GetSMEFactories`;
    return this.http.get<any>(url, this.httpOptions);
  }
  public getFocusAreas() {
    const url = `${this.apiUrl}SME/GetFocusAreas`;
    return this.http.get<any>(url, this.httpOptions);
  }
  public getSubcompetencies(compId) {
    const url = `${this.apiUrl}Competency/GetSubCompetenciesForDropDowns?competencyId=${compId}`;
    return this.http.get<any>(url, this.httpOptions);
  }
  public downloadCerificate(fileId) {
    const url = this.apiUrl + 'Certificate/Download?certificatedId=' + fileId;
    return this.http.get<any>(url, this.httpOptions);
  }

  public uploadSwotExcel(id, formData) {
    const url = `${this.apiUrl}Profile/UploadSWOTMatrixSheet/${id}`;
    return this.http.post<any>(url, formData, this.httpOptions);
  }
  getCompetencies() {
    const url = `${this.apiUrl}Competency/GetCompetenciesForDropDowns`;
    return this.http.get<any>(url, this.httpOptions);
  }
  public getServiceAreasInfo(id) {
    const url = `${this.apiUrl}Competency/GetServiceAreasByCompetencyId?competencyId=${id}`;
    return this.http.get<any>(url, this.httpOptions);
  }
  public getUserNotifications(from, size) {
    const url = `${this.apiUrl}Notification/GetNotifications?from=${from}&size=${size}`;
    return this.http.get<any>(url, this.httpOptions);
  }
  public getEmployeesByCompId(from: number, size: number, competencyId, resumeupload, profileStatus, subCompetencyId, subCompetency, searchText, country: any[], IsCertified: number, AvailabilityStatus: number, ResignedStatus: number, isNotUpdatedSince3Months: boolean, isSme: number, isExportExcel : boolean) {
    if (country == null) {
      country = null;
    }
    let url = `${this.apiUrl}Profile/FetchEmployeesbyCompetencyId?from=${from}&size=${size}&competencyId=${competencyId}&isExcelExport=${isExportExcel}`;
    url = this.buildFetchEmployeeByCompIdUrl(url, resumeupload, profileStatus, subCompetencyId, searchText, country, IsCertified, AvailabilityStatus, ResignedStatus, isNotUpdatedSince3Months, isSme)
    return this.http.get<any>(url, this.httpOptions);
  }

  public searchEmployee(from: number, size: number, searchText) {

    let url = `${this.apiUrl}Profile/FetchEmployees?searchTerm=${searchText}&from=${from}&size=${size}`;
    return this.http.get<any>(url, this.httpOptions);
  }
  public managerApprovalbycompetenyId(ApproveAll: boolean, CompetencyId: number, employeeIds: []) {
    const url = `${this.apiUrl}Profile/BulkApprove`;
    return this.http.post<any>(url, { ApproveAll, CompetencyId, employeeIds }, this.httpOptions);
  }

  public downloadResume(sharepointId) {
    const url = `${this.apiUrl}Template/downloadResumeAndCertificate/${sharepointId}`;
    return this.http.get<any>(url, this.httpOptions);
  }
  public downloadTemplate(sharepointId) {
    const url = `${this.apiUrl}Template/downloadResumeAndCertificate/${sharepointId}`;
    return this.http.get<any>(url, this.httpOptions);
  }
  public getFilteredResources(from: number, size: number, competencyId: number, Resumestatus: number, available: number, subCompetencyId, subCompetency: string, searchText) {
    let url = `${this.apiUrl}Profile/GetFilteredResources?from=${from}&size=${size}&Resources=${available}&competencyId=${competencyId}`;
    url = this.bulidFilterResourseUrl(url, subCompetency, searchText)
    return this.http.get<any>(url, this.httpOptions);
  }
  bulkUploadEmployees() {
    let url = `${this.apiUrl}RefreshEmployeeData/BulkUploadEmployees`;
    return this.http.get<any>(url, this.httpOptions);
  }
  getLastAutoSync() {
    let url = `${this.apiUrl}RefreshEmployeeData/GetLastAutoSync`;
    return this.http.get<any>(url, this.httpOptions);
  }

  updateNotification(notificationIds: string[]) {
    const url = this.apiUrl + `Notification/UpdateNotification`;
    return this.http.post<any>(url, notificationIds, this.httpOptions);
  }
  public IsEmployeeRequestedForCompetencyAndSubCompetency( employeeId: number) {
    const url = `${this.apiUrl}EmployeeCompetencyAndSubCompetency/IsEmployeeRequestedForCompetencyAndSubCompetency?employeeId=${employeeId}`;
    return this.http.get<any>(url, this.httpOptions);
  }
  public mapEmployeeCompetencyAndSubCompetency( employeeId: number) {
    const url = `${this.apiUrl}EmployeeCompetencyAndSubCompetency/Map?employeeId=${employeeId}`;
    return this.http.get<any>(url, this.httpOptions);
  }
  public requestCompetencyAndSubCompetency(requestData) {
    const url = `${this.apiUrl}EmployeeCompetencyAndSubCompetency/Request`;
      return this.http.post<any>(url,requestData, this.httpOptions);
  }
  public confirmEmployeeCompetencyAndSubCompetency(requestData) {
    const url = `${this.apiUrl}EmployeeCompetencyAndSubCompetency/Confirm`;
      return this.http.post<any>(url,requestData, this.httpOptions);
  }
}
